//#region src/logger/root-logger.ts
let rootLogger = void 0;
const setRootLogger = (logger) => {
	rootLogger = logger;
};
const getRootLogger = () => {
	if (!rootLogger) throw new Error("You must set root logger first");
	return rootLogger;
};
//#endregion
export { getRootLogger, setRootLogger };
